/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type InvestorDocumentWorkflowInvestmentWorkflowRes = {
    investmentWorkflowId: string;
    investmentWorkflowType: InvestorDocumentWorkflowInvestmentWorkflowRes.investmentWorkflowType | null;
    isReleased: boolean | null;
    date: string | null;
};

export namespace InvestorDocumentWorkflowInvestmentWorkflowRes {

    export enum investmentWorkflowType {
        JOINER_CREATE = 'JOINER_CREATE',
        JOINER = 'JOINER',
        ALLOCATION = 'ALLOCATION',
        LEAVER = 'LEAVER',
    }


}

